import get from 'lodash.get';

const ORIGINAL_QUERY_PARAM_KEY = 'oq';

export const createHashFragmentMap = (hash = '') => {
    const hashArray = hash.replace('#', '').split('?');
    const segments = hashArray[0].split('/').filter(segment => segment);
    const params = hashArray[1]
        ? hashArray[1].split('&').map(param => {
              const [key, value] = param.split('=');
              return {
                  key,
                  value,
              };
          })
        : [];
    return {
        segments,
        params,
    };
};

export const hashFragmentMapToString = (map = {}) => {
    const { segments = [], params = [] } = map;

    const segmentString = segments.join('/');
    const paramsString = params.reduce((string, param, index) => {
        return `${string}${index === 0 ? '?' : ''}${param.key}=${param.value}${
            index + 1 === params.length ? '' : '&'
        }`;
    }, '');
    return segmentString || paramsString ? `#${segmentString}${paramsString}` : '';
};

export const getOriginalQueryHashParamValue = hash => {
    const { params } = createHashFragmentMap(hash);
    const oqParam = params.find(param => param.key === ORIGINAL_QUERY_PARAM_KEY);

    return get(oqParam, 'value');
};

export const removeOriginalQueryHashParamValue = hash => {
    const { segments, params } = createHashFragmentMap(hash);
    const removeOq = params.filter(param => param.key !== ORIGINAL_QUERY_PARAM_KEY);

    return hashFragmentMapToString({ segments, params: removeOq });
};
